import React, { ReactElement, useCallback, memo } from 'react';
import { Box, Typography } from '@mui/material';
import classNames from 'classnames';

import StyledSubmitButton from '../../../../../components/Shared/StyledSubmitButton';

interface IGiftCardReadyLinkProps {
  link: string;
}

const GiftCardReadyLink = ({ link }: IGiftCardReadyLinkProps): ReactElement => {
  const handleClickLink = useCallback(() => window.open(link, '_blank'), [link]);
  return (
    <Box
      bgcolor="green.light"
      border={2}
      borderColor="green.main"
      borderRadius="8px"
      textAlign="center"
      py={[2, 5]}
      px={[3, 15]}
      maxWidth={495}
      mx={[4, 'auto']}
    >
      <Box mb={3}>
        <Typography className={classNames('H4-Dark-Bold', 'textPrimary-ie')}>Your gift card is ready!</Typography>
      </Box>
      <StyledSubmitButton width="100%" onClick={handleClickLink}>
        Claim your gift card now
      </StyledSubmitButton>
    </Box>
  );
};

export default memo(GiftCardReadyLink);
